export enum QueryOperatorsEnum {
	equal = '$eq',
	notEqual = '$ne',
	notIn = '$nin',
	include = '$in',
	greaterThan = '$gt',
	lessThanOrEqual = '$lte',
	greaterThanOrEqual = '$gte',
	regex = '$regex'
}
